import freightApi2 from "../../service/modules/freight.api";
import {
  FREIGHT_STATUS_CANCELABLE_CODES,
  resolveStatusCode,
} from "../../view/frete-copy/action/action";

export function canCancelFreightStatus(statusCode) {
  const normalized = String(statusCode ?? "").padStart(2, "0");
  return FREIGHT_STATUS_CANCELABLE_CODES.includes(normalized);
}

export function resolveFreightStatusCode(statusValue, fallbackDescribe = "") {
  return resolveStatusCode(statusValue, fallbackDescribe);
}

export function getCancelFreightErrorMessage(
  error,
  fallback = "Não foi possível cancelar o frete.",
) {
  return (
    error?.response?.data?.message ??
    error?.response?.data?.error ??
    error?.response?.data?.msg ??
    error?.message ??
    fallback
  );
}

/**
 * Cancela um frete via API (contrato api-core-comunicacao).
 * @param {string} freightId
 * @param {string} reason
 * @param {{ idUser: string, viewAll?: boolean }} options
 */
export async function cancelFreightById(
  freightId,
  reason,
  { idUser, viewAll = false } = {},
) {
  if (!freightId) {
    throw new Error("ID do frete não informado.");
  }
  if (!String(reason ?? "").trim()) {
    throw new Error("Motivo do cancelamento é obrigatório.");
  }
  if (!String(idUser ?? "").trim()) {
    throw new Error("Usuário logado não identificado.");
  }

  return freightApi2.cancel(freightId, String(reason).trim(), {
    idUser: String(idUser).trim(),
    viewAll: Boolean(viewAll),
  });
}
